import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

/**
 * Hook de permisos (Fase 1). Lee `usuario.permisos` (viene de GET /api/auth/me,
 * ya con el efectivo usuario > rol > catálogo resuelto en backend).
 *
 * Si `permisos` aún no ha cargado (primer render, o localStorage con un
 * usuario guardado antes de esta funcionalidad) se devuelve el valor más
 * permisivo, igual que hace el backend por defecto, para no ocultar/bloquear
 * nada de golpe mientras se resuelve `/auth/me`.
 */
export function usePermiso() {
  const { usuario } = useAuth();
  const permisos = usuario?.permisos;

  return useMemo(() => {
    const puede = (nodeId, cap = "ver") => {
      const valor = permisos?.[nodeId]?.[cap];
      if (valor === undefined) return true;
      return valor === true;
    };

    const alcance = (nodeId, cap = "alcance_ver") => {
      const valor = permisos?.[nodeId]?.[cap];
      if (typeof valor === "string") return valor;
      return "todos";
    };

    const esPropio = (nodeId, cap = "alcance_ver") => alcance(nodeId, cap) === "propio";

    return { puede, alcance, esPropio, permisos: permisos || {} };
  }, [permisos]);
}

export default usePermiso;
